export const CUSTOM_HEADER_HEIGHT = 77
